<template>
  <div class="event-item-root-container">
    <div class="event-item-title-row-container">
      <my-avatar :name="dataSource.create_user_name" :img_url="dataSource.create_user_img_url" :size="24"></my-avatar>
      <div class="event-item-title-container">
        <span style="font-size:15px;font-weight:500;">{{ dataSource.create_user_name }}</span>
        <span style="font-size:13px;font-weight:500;color:#404040;margin: 0 10px;">(内部成员)</span>
        <span style="font-size:15px;font-weight:500;">创建了</span>
        <span style="font-size:15px;font-weight:500;color:#104266;margin-left: 10px;">付款请求单</span>
      </div>
    </div>
    <div class="event-item-createtime-container">{{ dataSource.create_time }}</div>
    <div class="event-item-bill-container">
      <img :src="icons.milestoneType2" style="width:32px;height:37px;" />
      <div class="event-item-bill-item-container" style="flex:1;margin-left: 15px;">
        <div style="font-size:13px;font-weight: bold;color:#050505;">{{ dataSource.name }}</div>
        <div
          style="font-size:12px;font-weight: 500;color:#5E5E5E;margin-top:5px;"
        >@{{ dataSource.project_name }}</div>
      </div>
      <div class="event-item-bill-item-container" style="align-items:flex-end;">
        <fee :amount="dataSource.total_amount" :primarySize="13" :secondarySize="12" />
        <div
          style="margin-top:5px;font-size:12px;font-weight:500;color:#747474;"
        >包含0个任务,共计{{ dataSource.count }}人</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as icon from "../../../common/icon";
import Fee from "../../../components/Fee";
import MyAvatar from "../../../components/MyAvatar";
export default {
  components: {
    fee: Fee,
    "my-avatar": MyAvatar,
  },
  props: {
    dataSource: Object,
  },
  data() {
    return {
      icons: icon,
    };
  },
};
</script>

<style scoped>
.event-item-root-container {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  min-width: 540px;
  height: 140px;
  padding: 15px;
  margin-right: 15px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 0px 1px #dddddd;
}
.event-item-root-container:hover {
  box-shadow: 0px 0px 10px #dddddd;
}
.event-item-check {
  position: absolute;
  top: 15px;
  right: 15px;
}
.event-item-title-row-container {
  display: flex;
  flex-direction: row;
}
.event-item-title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 15px;
}
.event-item-bill-container {
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  padding: 10px 20px;
  margin: 0 40px;
  background-color: #f6f7f8;
}
.event-item-bill-item-container {
  display: flex;
  flex-direction: column;
}
.event-item-createtime-container {
  font-size: 12px;
  font-weight: 500;
  margin-left: 40px;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>